import { HTTP_SERVER_ERROR } from '../constants';
import type { TFetchError } from '../types';

interface GraphQLErrorExtension {
	extensions?: {
		statusCode?: number | null;
	} | null;
	message: string | null | undefined;
}

export function buildMutationError(
	errors: ReadonlyArray<GraphQLErrorExtension | null> | null | undefined,
): TFetchError {
	const error =
		errors && errors.length > 0
			? errors[0]
			: {
					message: '',
					extensions: { statusCode: HTTP_SERVER_ERROR },
				};
	return {
		message: error?.message ?? '',
		status: error?.extensions?.statusCode ?? HTTP_SERVER_ERROR,
	};
}

